import { call, put, takeLatest } from "redux-saga/effects";
import { GET_DashboardOverview, GET_DashboardOverdueTasks, GET_DashboardMyTasks, GET_DashboardActivities, GET_DashboardProjectOverview } from "../services/Dashboard";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_DashboardOverviewEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DashboardOverview, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DashboardOverview", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_DashboardOverdueTasksEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DashboardOverdueTasks, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DashboardOverdueTasks", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_DashboardMyTasksEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DashboardMyTasks, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DashboardMyTasks", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_DashboardActivitiesEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DashboardActivities, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DashboardActivities", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_DashboardProjectOverviewEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_DashboardProjectOverview, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_DashboardProjectOverview", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_DashboardOverview", GET_DashboardOverviewEffect);
  yield takeLatest("GET_DashboardOverdueTasks", GET_DashboardOverdueTasksEffect);
  yield takeLatest("GET_DashboardMyTasks", GET_DashboardMyTasksEffect);
  yield takeLatest("GET_DashboardActivities", GET_DashboardActivitiesEffect);
  yield takeLatest("GET_DashboardProjectOverview", GET_DashboardProjectOverviewEffect);
}
